import { render, staticRenderFns } from "./messageDetail.vue?vue&type=template&id=a750afb8&scoped=true"
import script from "./messageDetail.vue?vue&type=script&lang=js"
export * from "./messageDetail.vue?vue&type=script&lang=js"
import style0 from "./messageDetail.vue?vue&type=style&index=0&id=a750afb8&prod&lang=scss&scoped=true"
import style1 from "./messageDetail.vue?vue&type=style&index=1&id=a750afb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a750afb8",
  null
  
)

export default component.exports